import { apiClientVersioned, returnData } from '../index'

import type { IPaginatedResponse } from '../index'
import type {
  IGpt,
  IGptData,
  IGptListFilters,
  IGptListItem,
  IGptPinOrderBody,
} from '../types/gpt'
import type { IRating, IRatingData } from '../types/rating'

export const GptApi = {
  /**
   * Returns the list of GPTs with pagination and search option.
   */
  list: (
    filters?: Partial<IGptListFilters>,
    options?: { signal?: AbortSignal },
  ) =>
    returnData(
      apiClientVersioned.get<IPaginatedResponse<IGptListItem>>('/gpts', {
        params: filters,
        paramsSerializer: {
          indexes: null,
        },
        signal: options?.signal,
      }),
    ),
  get: (id: string) => returnData(apiClientVersioned.get<IGpt>(`/gpts/${id}`)),
  create: (data: IGptData) =>
    returnData(apiClientVersioned.post<IGpt>('/gpts', data)),
  update: (data: IGpt | Omit<IGpt, 'config'>) =>
    returnData(apiClientVersioned.put<IGpt>(`/gpts/${data.id}`, data)),
  remove: (id: string) =>
    returnData(apiClientVersioned.delete<IGpt>(`/gpts/${id}`)),

  // Non REST API
  togglePin: (id: string) =>
    returnData(
      apiClientVersioned.post<{ pinned: boolean }>(`/gpts/${id}/toggle-pinned`),
    ),
  /**
   * Sets pinned GPT order for the current user. Returns 204 No Content on success.
   */
  setPinOrder: (
    body: IGptPinOrderBody,
    params?: { skip_auto_commit?: boolean },
  ) =>
    returnData(
      apiClientVersioned.post<void>(`/gpts/pin-order`, body, {
        params,
      }),
    ),
  rateGpt: (gptId: string, data: IRatingData) =>
    returnData(
      apiClientVersioned.post<IRating>(`/gpts/${gptId}/ratings`, data),
    ),
}
